import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDownregular = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 256 256",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 16,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M63.2,99.2L128,167.6L192.8,99.2"
	})
});
export default SvgCaretDownregular;
